import {
  TOGGLE_USER_INFO_MODAL,
  TOGGLE_SUB_MENU,
  TOGGLE_MOBILE_SUB_MENU,
  UPDATE_STATUS_BAR_CONTENT,
  TOGGLE_MOBILE_MENU,
  STATUS_BAR_RESET_STATE,
  SHOW_SESSION_EXPIRED_MODAL,
} from './actions'

const initialState = {
  openUserInfoModal: false,
  openSubMenu: false,
  openMobileSubMenu: false,
  statusBarContent: [],
  openMobileMenu: false,
  showSessionExpiredModal: false
}

// Action handler
export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_USER_INFO_MODAL:
      return {
        ...state,
        openUserInfoModal: !state.openUserInfoModal
      }
    case TOGGLE_SUB_MENU:
      return {
        ...state,
        openSubMenu: !state.openSubMenu
      }
    case TOGGLE_MOBILE_SUB_MENU:
      return {
        ...state,
        openMobileSubMenu: !state.openMobileSubMenu
      }
    case UPDATE_STATUS_BAR_CONTENT:
      return {
        ...state,
        statusBarContent: action.statusBarContent
      }
    case STATUS_BAR_RESET_STATE:
      return {
        ...state,
        statusBarContent: [],
      }
    case TOGGLE_MOBILE_MENU:
      return {
        ...state,
        openMobileMenu: !state.openMobileMenu
      }
    case SHOW_SESSION_EXPIRED_MODAL:
      return {
        ...state,
        showSessionExpiredModal: true
      }
    default:
      return state
  }
}

// Actions
export const toggleUserInfoModal = () => ({
  type: TOGGLE_USER_INFO_MODAL
})

export const toggleSubMenu = () => ({
  type: TOGGLE_SUB_MENU
})

export const toggleMobileSubMenu = () => ({
  type: TOGGLE_MOBILE_SUB_MENU
})

export const updateStatusBar = (statusBarContent) => ({
  type: UPDATE_STATUS_BAR_CONTENT,
  statusBarContent
})

export const toggleStatusBar = (message) => {
  return (dispatch, getState) => {
    let state = getState()
    let statusBarContent = state.settings.statusBarContent

    statusBarContent = statusBarContent.filter(item => item !== message)

    dispatch(updateStatusBar(statusBarContent))
  }
}

export const toggleMobileMenu = () => ({
  type: TOGGLE_MOBILE_MENU
})

export const resetStateStatusBar = () => ({
  type: STATUS_BAR_RESET_STATE
})

export const showSessionExpiredModal = () => ({
  type: SHOW_SESSION_EXPIRED_MODAL
})


// WEBPACK FOOTER //
// ./src/modules/settings.js